module.exports = __webpack_public_path__ + "img/slide1-bg.ff2b89d4.webp";